import {useState} from 'react';

/**
 * Shared voice-input state for chat input bars.
 * Returns the three voice-mode state values plus a helper that builds the
 * standard MicButton prop bag for a given (inputValue, setInputValue, isLoading) tuple.
 * @return {{voiceMode: boolean, voicePreview: string, voiceWarning: string, micButtonProps: Function}}
 */
export function useVoiceInput() {
  const [voiceMode, setVoiceMode] = useState(false);
  const [voicePreview, setVoicePreview] = useState('');
  const [voiceWarning, setVoiceWarning] = useState('');

  const micButtonProps = (inputValue, setInputValue, isLoading) => {
    const micButtonPropsSet = {
      value: inputValue,
      onChange: setInputValue,
      onVoiceModeChange: setVoiceMode,
      onTranscriptPreview: setVoicePreview,
      onWarning: setVoiceWarning,
      disabled: isLoading,
    };

    return micButtonPropsSet;
  };

  return {voiceMode, voicePreview, voiceWarning, micButtonProps};
}
